import type { DefaultError, UseMutationOptions } from "@tanstack/vue-query";
import type {
  HydraMutationOptions,
  MutationDeleteVariables,
  MutationUrlVariables,
} from "./hydraMutations";
import { useMutation } from "@tanstack/vue-query";
import { getQueryClient } from "@verbleif/lib/src/composables/Query/queryClient";
import {
  deleteMutation,
  patchMutation,
  postMutation,
  putMutation,
} from "./hydraMutations";

export function usePostMutation<
  TData,
  TBody = unknown,
  TError = DefaultError,
  TOnMutateResult = unknown,
>(
  options: HydraMutationOptions<TData, TError, MutationUrlVariables<TBody>, TOnMutateResult> = {},
) {
  return useMutation(postMutation<TData, TBody, TError, TOnMutateResult>(options), getQueryClient());
}

export function usePatchMutation<
  TData,
  TBody = unknown,
  TError = DefaultError,
  TOnMutateResult = unknown,
>(
  options: HydraMutationOptions<TData, TError, MutationUrlVariables<TBody>, TOnMutateResult> = {},
) {
  return useMutation(patchMutation<TData, TBody, TError, TOnMutateResult>(options), getQueryClient());
}

export function usePutMutation<
  TData,
  TBody = unknown,
  TError = DefaultError,
  TOnMutateResult = unknown,
>(
  options: HydraMutationOptions<TData, TError, MutationUrlVariables<TBody>, TOnMutateResult> = {},
) {
  return useMutation(putMutation<TData, TBody, TError, TOnMutateResult>(options), getQueryClient());
}

export function useDeleteMutation<
  TData = void,
  TError = DefaultError,
  TOnMutateResult = unknown,
>(
  options: HydraMutationOptions<TData, TError, MutationDeleteVariables, TOnMutateResult> = {},
) {
  return useMutation(deleteMutation<TData, TError, TOnMutateResult>(options), getQueryClient());
}

export function useAppMutation<
  TData = unknown,
  TError = DefaultError,
  TVariables = void,
  TOnMutateResult = unknown,
>(
  options: UseMutationOptions<TData, TError, TVariables, TOnMutateResult>,
) {
  return useMutation(options, getQueryClient());
}
